import { initDownloadActions } from '../../js/modules/download.js';
import { accordion } from '../../js/modules/accordion.js';

(function () {
    let pagination_page = 1;
    let form = document.querySelector('[data-searchform');
    let ajaxUrl = php_vars.ajaxUrl;

    window.addEventListener('load', function () {
        initSmallSearchForm();
        initSearchForm();
    });

    function initSmallSearchForm() {
        let searchButton = document.querySelector('.topSearch--button');
        let close = document.querySelector('.topSearch--close');
        let searchForm = document.querySelector('.topSearch');
        let input = document.querySelector('.topSearch--inner input');

        if (searchButton) {
            searchButton.addEventListener('click', function (e) {

                if (!searchForm.classList.contains('is-active')) {
                    e.preventDefault();
                    searchForm.classList.add('is-active');
                    input.focus();
                }
            });
        }

        if (close) {
            close.addEventListener('click', function (e) {
                e.preventDefault();
                searchForm.classList.remove('is-active');
            });
        }
    }

    function pagination() {
        let pagination = document.querySelectorAll('.pagination a');
        if (pagination) {
            pagination.forEach(function (item) {
                item.addEventListener('click', function (e) {
                    e.preventDefault();

                    let url_string = item.getAttribute('href');
                    let url = new URL(url_string);
                    let page_no = url.searchParams.get("paged");

                    gsap.to(window, { scrollTo: 0 });

                    //CHANGE GLOBAL PAGE NUMBER
                    //AND LAUNCH SEARCH
                    pagination_page = page_no;
                    search();


                });
            });
        }
    }

    function initSearchForm() {
        if (form) {
            initButtonActions();
            initSearchFormAction();
            search();
        }
    }
    function initButtonActions() {
        let categoryButtons = document.querySelectorAll('[data-searchCategory] .button');

        if (categoryButtons.length) {
            categoryButtons.forEach(function (item) {
                item.addEventListener('click', function (e) {
                    e.preventDefault();

                    if (!item.classList.contains('is-active')) {
                        let activeElem = document.querySelector('[data-searchcategory] .button.is-active');

                        if (activeElem) {
                            activeElem.classList.remove('is-active');
                        }
                        item.classList.add('is-active');
                        pagination_page = 1;
                        search();
                    }
                })
            })
        }
    }
    function initSearchFormAction() {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            search();
        });
    }
    function search() {
        let container = document.querySelector('#object-list');
        let phrase = form.querySelector('[name="s"]').value;
        let category = document.querySelector('[data-searchCategory] .is-active').getAttribute('data-value');
        let loader = document.querySelector('.loader');
        var openAll = false;
        let filterObject = {
            phrase: phrase,
            category: category,
            action: 'searchResults',
            paged: pagination_page
        }



        jQuery.ajax({
            type: 'post',
            url: ajaxUrl,
            data: filterObject,
            beforeSend: function () {
                container.innerHTML = '';
                loader.classList.add('visible');
            },
            error: function (error) {
                console.log(error);
            },
            success: function (response) {
                loader.classList.remove('visible');
                container.innerHTML = response;

                initDownloadActions();
                accordion(openAll);
                pagination();
            }
        });
    }
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/search.js
// module id = 21
// module chunks = 0